import { z } from 'zod';

/**
 * Buchbares Zeitfenster (BookingBusinessHours), interne Sicht. Wird über den
 * sicheren Custom-Endpoint /bookingbusinesshours/config gelesen/geschrieben:
 * FromTime/ToTime sind dort "HH:MM:SS"-Strings, FKs als Alias-Keys
 * (idMeetingType/idLocation/idUser). NULL bedeutet:
 *   idLocation    NULL -> global (standortunabhängig)
 *   idMeetingType NULL -> gilt für alle Terminarten
 */
export const bookingBusinessHoursSchema = z.object({
  idBookingBusinessHours: z.number().default(-1),
  Weekday: z.number().default(1),
  FromTime: z.string().default('09:00:00'),
  ToTime: z.string().default('17:00:00'),
  idMeetingType: z.number().nullable().default(null),
  idLocation: z.number().nullable().default(null),
  idUser: z.number().nullable().default(null),
});

export type IBookingBusinessHours = z.infer<typeof bookingBusinessHoursSchema>;

export const bookingBusinessHoursResponseSchema = z.object({
  bookingBusinessHours: z.array(bookingBusinessHoursSchema),
});

export const WEEKDAYS: { value: number; label: string }[] = [
  { value: 1, label: 'Montag' },
  { value: 2, label: 'Dienstag' },
  { value: 3, label: 'Mittwoch' },
  { value: 4, label: 'Donnerstag' },
  { value: 5, label: 'Freitag' },
  { value: 6, label: 'Samstag' },
  { value: 7, label: 'Sonntag' },
];
